var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-body"},[_c('div',{staticClass:"company"},[_c('banner',{ref:"banner",attrs:{"titleId":_vm.titleId}})],1),(_vm.nodeId[_vm.titleId])?_c('div',{staticClass:"main-children__body"},[_c('router-view')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }